import Layout from "@/components/Layout";

const Disclaimer = () => (
  <Layout>
    <div className="container mx-auto max-w-2xl px-4 py-10 space-y-6 text-slate-200">
      <h1 className="text-2xl font-bold text-white">Disclaimer</h1>
      <p className="text-sm text-slate-400">Last updated: March 2026</p>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Not professional advice</h2>
        <p className="text-sm text-slate-300">
          Nothing produced by ScopSift constitutes legal, medical, financial or professional advice. Reports and copy are generated for informational and commercial-listing purposes only.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Source accuracy</h2>
        <p className="text-sm text-slate-300">
          Evidence is gathered from public web sources and any review text you paste. This information may be inaccurate, incomplete or outdated. We do not guarantee the correctness of any output.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Personal information</h2>
        <p className="text-sm text-slate-300">
          Do not paste personal or sensitive information into the tool. ScopSift is designed to process product reviews, not personal data.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Verify before publishing</h2>
        <p className="text-sm text-slate-300">
          Always verify facts, claims and evidence before using generated content in advertisements, product listings or any other public-facing material. You are solely responsible for the accuracy of anything you publish.
        </p>
      </section>
    </div>
  </Layout>
);

export default Disclaimer;
